import { useState } from 'react';
import '../App.css';
import logo from '../contents/app-logo-on-light.png';
import httpClient from '../../../../packages/shared-http/src/httpClient';
import { Button } from "@castandcrew/platform-ui";

function Home() {
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleApiCall = async () => {
    setLoading(true);
    setError(null);
    setApiData(null);

    try {
      // Example public API call - JSONPlaceholder
      const response = await httpClient.get('https://jsonplaceholder.typicode.com/posts/1');
      setApiData(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Home" style={{ padding: '20px' }}>
      <h2>Home Component</h2>

      <div style={{ marginTop: '20px' }}>
        <button
          onClick={handleApiCall}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          🌐 Test API Call
        </button>
        <Button>Press Me</Button>
      </div>

      {/* API Call Result Display */}
      {(loading || apiData || error) && (
        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f3f4f6',
          borderRadius: '4px',
          border: '1px solid #e5e7eb'
        }}>
          {loading && <div>Loading...</div>}
          {error && <div style={{ color: '#dc2626' }}>Error: {error}</div>}
          {apiData && (
            <div>
              <strong>API Response:</strong>
              <pre style={{
                margin: '10px 0 0 0',
                padding: '10px',
                backgroundColor: '#1f2937',
                color: '#f9fafb',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '14px'
              }}>
                {JSON.stringify(apiData, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Home;